<template>
  <slot v-if="isGuestPage || isUserEnsured" />
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { provideAuth } from 'src/composables/useAuth';
import { usePageType } from 'src/composables/usePageType';

const { userResolved } = provideAuth();
const { isGuestPage } = usePageType();
const router = useRouter();

const isUserEnsured = ref<boolean>(false);

// 初期ナビゲーション解決前は route.name が未確定で isGuestPage を誤判定するため、
// router の準備完了を待ってからガードを開始する
const isRouterReady = ref<boolean>(false);

const guardRoute = async(): Promise<void> => {
  if (!isRouterReady.value) return;

  if (isGuestPage.value) {
    isUserEnsured.value = false;
    return;
  }
  if (isUserEnsured.value) return;

  try {
    await userResolved();
    isUserEnsured.value = true;
  } catch {
    isUserEnsured.value = false;
    await router.push({ name: 'Login' });
  }
};

watch([isRouterReady, isGuestPage], guardRoute, { immediate: true });

onMounted(async() => {
  try {
    await router.isReady();
    isRouterReady.value = true;
  } catch {
    // 初期ナビゲーションが失敗した場合はガードを開始しない（従来の挙動を維持）
  }
});
</script>
